import theme from '../../themes/green';

const styles = {
  wrapper: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: theme.pallete.background,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  spinnerColor: theme.pallete.color
}

export default styles;


// WEBPACK FOOTER //
// ./src/components/LoadingOverlay/styles.js